@for (toast of toastService.toasts; track toast.id) {
    <ngb-toast
        [class]="toast.toastType"
        [autohide]="toast.autoHide"
        [delay]="toast.delay || 5000"
        [attr.data-testid]="'toast-' + toast.toastType + '-message'"
        (hidden)="toastService.remove(toast)"
    >
        <div class="toast-content">
            <span [attr.data-testid]="'toast-' + toast.id + '-message'">{{toast.message}}</span>
        
            @if(toast.showCloseButton || toast.toastType == TOAST_TYPE.ERROR) {
                <button class="close-btn" [attr.data-testid]="'toast-' + toast.id + '-remove-button'" (click)="toastService.remove(toast)">x</button>
            }
        </div>
        
    </ngb-toast>
}
